import {Component, Inject, OnInit} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, NotificationService} from '../../_services/index';
import {DOCUMENT} from "@angular/common";

@Component({
    standalone: false,
  selector: "unsubscribe-notification-component",
  templateUrl: 'unsubscribe.notification.component.html',
})

export class UnsubscribeNotificationComponent implements OnInit {
  finished: boolean;

  constructor(
    @Inject(DOCUMENT) public document,
    public router: Router,
    public notificationService: NotificationService,
    public authenticationService: AuthenticationService,
    public route: ActivatedRoute,
    public alertService: AlertService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(t => {
      this.notificationService.unsubscribeNotification(t['type'], t['key'], t['tenantName']).subscribe(
        data => {
          this.finished = true;
        },
        error => {
        });
    });
  }
}

